import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import relativeTime from 'dayjs/plugin/relativeTime';
import router from './routes';
import { PRIMARY_COLOR } from './theme/colors';
import 'antd/dist/reset.css';
import './index.css';

// Configuration de dayjs en français pour correspondre à la locale d'Ant Design
dayjs.locale('fr');
dayjs.extend(relativeTime);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={frFR}
        theme={{
          token: {
            // Aligne Ant Design sur l'accent unique de l'application
            // (il utilisait son bleu par défaut #1890ff)
            colorPrimary: PRIMARY_COLOR,
            // Aligne les composants Ant Design sur la police du reste de l'application
            fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
          },
        }}
      >
        <RouterProvider router={router} />
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
